import * as types from '../../constants/log/googleStorePurchaseLogContstants';

export const googleStorePurchaseLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  productNo,
  productId,
  orderId,
  purchaseToken,
  // postNo,
  // productType,
  // itemList,
  // purchaseNo,
  // purchaseTime,
  // purchaseStatus,
  // refundedAt,
  // regionCode,
  // updatedAt,
  callback,
  error,
}) => ({
  type: types.GOOGLE_STORE_PURCHASE_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  productNo,
  productId,
  orderId,
  purchaseToken,
  // postNo,
  // productType,
  // itemList,
  // purchaseNo,
  // purchaseTime,
  // purchaseStatus,
  // refundedAt,
  // regionCode,
  // updatedAt,
  callback,
  error,
});

export const googleStorePurchaseLogList = (list) => ({
  type: types.GOOGLE_STORE_PURCHASE_LOG_LIST,
  list,
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setGoogleStorePurchaseLogPagination = (
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
) => ({
  type: types.SET_GOOGLE_STORE_PURCHASE_LOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});
